import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class PromotionsService extends BaseService {

  constructor() {
    super();
  }

  // Get all countries list
  getCarrierCountries() {
    return this.httpService.get(APIUrl.country)
  }
  // Get all Carriers
  getCarriers() {
    return this.httpService.get(APIUrl.carriers)
  }

  //Get codeGroup
  getcodeGroups() {
    let params = new HttpParams().set('config_name', 'InvoiceGrouping');
    return this.httpService.getRetailerData(APIUrl.congifValues, params)
  }
  //Get Tiers
  getTiers() {
    let params = new HttpParams().set('config_name', 'Tier');
    return this.httpService.getRetailerData(APIUrl.congifValues, params)
  }

  // Occasion rewards --> list of festivals
  getOccasionFestivals(): Observable<any> {
    let url = APIUrl.occasionsList;
    return this.httpService.get(url)
  }
  // Occasion rewards --> festivals history
  getOccasionFestivalsHistory(endDate, startDate): Observable<any> {
    let url = APIUrl.occasionsList;
    let params: any = new HttpParams().set('endDate', endDate).set('startDate', startDate)
    return this.httpService.getParams(url, params)
  }

  getOccasionsFestivalRefreshed(): Observable<any> {
    let url = APIUrl.occasionsRefresh;
    return this.httpService.get(url);
  }
   // Add new Banner
  //  addNewBanner(params) {
  //   //let url = APIUrl.provider + `/` + APIUrl.save;
  //   return this.httpService.post(APIUrl.addBanner, params);
  // }
  // addNewBanner(FormData){
  //   let url = `${APIUrl.addBanner}`;
  //   return this.httpService.post(url,FormData);
  // }
  addNewBanner(formData): Observable<any> {

    let url = APIUrl.addBanner;

    return this.httpService.post(url, formData)

  }
  // Get all loyalty rewards list
  getAllLoyaltyRewards(): Observable<any> {
    let url = APIUrl.allLoyaltyRewards;
    return this.httpService.get(url);
  }

  // Get loyalty rewards details by loyaltyId
  getLoyaltyRewardsDataById(id): Observable<any> {
    let url = `${APIUrl.allLoyaltyRewards}/${id}`;
    return this.httpService.get(url)
  }


  // Delete loyalty rewards by loyaltyId
  deleteLoyaltyRewardsDataById(id): Observable<any> {
    let url = `${APIUrl.deleteLoyaltyRewards}/${id}`;
    return this.httpService.delete(url);
  }

  // Add Loyalty Rewards Config
  addLoyaltyRewardsConfig(params): Observable<any> {
    let url = APIUrl.allLoyaltyRewards;
    return this.httpService.post(url, params)
  }

  // Update Loyalty Rewards Config
  updateLoyaltyRewardsConfig(params): Observable<any> {
    let url = APIUrl.allLoyaltyRewards;
    return this.httpService.put(url, params)
  }


  getAllLoyaltyPromotions(): Observable<any> {
    let url = APIUrl.allLoyaltyPromotions;
    return this.httpService.get(url);
  }

  getLoyaltyPromocodesDataById(id): Observable<any> {
    let url = `${APIUrl.allLoyaltyPromotions}/${id}`;
    return this.httpService.get(url)
  }

  // Add Loyalty Promocodes Config
  addLoyaltyPromocodesConfig(params): Observable<any> {
    let url = APIUrl.allLoyaltyPromotions;
    return this.httpService.post(url, params)
  }

  // Update Loyalty Promocodes Config
  updateLoyaltyPromocodesConfig(params): Observable<any> {
    let url = APIUrl.allLoyaltyPromotions;
    return this.httpService.put(url, params)
  }


  // Generate promocode
  generatePromocode(occassionId): Observable<any> {
    let url = APIUrl.generateSavePromo;
    let params = new HttpParams().set('occassionId', occassionId)
    return this.httpService.getParams(url, params)
  }

  getPromoCodesHistory(): Observable<any> {
    let url = APIUrl.getPromocodeHistory;
    let params = new HttpParams().set('type', 'occasion')
    return this.httpService.getParams(url, params);
  }

  generateSendPromo(formData): Observable<any> {
    let url = APIUrl.generateSavePromo;
    return this.httpService.post(url, formData);
  }

  savePromo(formData): Observable<any> {
    let url = APIUrl.generateSavePromo;
    return this.httpService.put(url, formData);
  }


  getPromoCodeByOccasion(occasionId): Observable<any> {
    let url = APIUrl.occaionPromoCode;
    let params = new HttpParams().set('occasionId', occasionId);
    return this.httpService.getParams(url, params)
  }

  sendNotification(promocodeId): Observable<any> {
    let url = `${APIUrl.sendNotificationPromo}/${promocodeId}`;
    return this.httpService.post(url, {})
  }
  getUserHistoryList(promocodeId): Observable<any> {
    let url = `${APIUrl.customerHistoryList}/${promocodeId}`;
    return this.httpService.get(url);
  }
  getCountryNames(codeGroup,tier){
    let url = `${APIUrl.countryNames}/${codeGroup}/${tier}`;
    //console.log(url);
    return this.httpService.get(url);
  }
  getCarrierNamesbycountry(country){
    let url = `${APIUrl.countrycarriers}/${country}`;
    return this.httpService.get(url);
  }
  getcarrierPromotions(){
    let url = `${APIUrl.carrierPromotions}`;
    return this.httpService.get(url);
  }
  updatecarrierPromotions(formData){
    let url = `${APIUrl.carrierPromotions}`;
    return this.httpService.put(url,formData);
  }
  addcarrierPromotions(formData){
    let url = `${APIUrl.carrierPromotions}`;
    return this.httpService.post(url,formData);
  }
  getcarrierPromotionsId(id){
    let url = `${APIUrl.carrierPromotions}/${id}`;
    return this.httpService.get(url);
  }
  getCarrierNamesbycountrycodegroup(country,codeGroups){
    let url = `${APIUrl.occationcarriers}`;
    let params = new HttpParams().set('country', country).set('codeGroups', codeGroups);
    return this.httpService.getParams(url,params);
  }
  getSKU(country,codeGroups,carrier){
    let url = `${APIUrl.skuList}`;
    let params = new HttpParams().set('country', country).set('codeGroups', codeGroups).set('carrier', carrier);
    return this.httpService.getParams(url,params);
  }

  getConsumerSkuList(country,codeGroups,carrier) {
    let url = `${APIUrl.consumerProductList}`;
    let params = new HttpParams().set('country', country).set('codeGroups', codeGroups).set('carrier', carrier);
    return this.httpService.getParams(url,params);

  }

  getCountries(codeGroup){
    let url = `${APIUrl.countryList}`;
    let params = new HttpParams().set('codeGroup', codeGroup);
    return this.httpService.getParams(url,params);
  }
  getCarriersList(codeGroup,country){
    let url = `${APIUrl.carrierList}`;
    let params = new HttpParams().set('codeGroup', codeGroup).set('country', country);
    return this.httpService.getParams(url,params);
  }
  getProductDetails(productId) {
    let url = `${APIUrl.products}/${productId}`;
    return this.httpService.get(url);
  }
  createfestival(params): Observable<any> {
    let url = APIUrl.festival;
    return this.httpService.post(url, params)
  }
  getfestival(festivalId){
    let url = `${APIUrl.festival}/${festivalId}`;
    return this.httpService.get(url);
  }
  updatefestival(params): Observable<any> {
    let url = APIUrl.festival;
    return this.httpService.put(url, params)
  }

  notifyUsersMessageCarrierPromo(id:any): Observable<any> {
    let url = `${APIUrl.notifyMessageToUser}/${id}`;
    return this.httpService.get(url)
  }
  getPromotionBanners(): Observable<any> {
    let url = APIUrl.getPromotionBanner;
    return this.httpService.get(url)
  }
  updatePromotionBanners(formData): Observable<any> {
    let url = APIUrl.updatePromoCodeBanner;
    return this.httpService.put(url, formData)
  }
  getretailerGrid(): Observable<any> {
    return this.httpService.get(APIUrl.retailerGrid);
  }

  mapRetailers(products){
    let url: string= APIUrl.mapRetailers;
    let params: any = new HttpParams().set('retailers',products)
    return this.httpService.put(url,params);
  }

  addVideoInstruction(formData): Observable<any> {
    let url = APIUrl.addVideos;
    return this.httpService.post(url, formData)

  }
  getVideoInstruction(): Observable<any> {
    let url = APIUrl.getVideos;
    return this.httpService.get(url)
  }

  updateVideos(params): Observable<any> {
    let url = APIUrl.updateVideos;
    return this.httpService.put(url, params)
  }
  getVideo(id) {
    return this.httpService.get(APIUrl.getVideoForUpdate + id);
  }
  postFile(fileToUpload: File) {
    //const endpoint = this.httpService.get(APIUrl.import)
    const formData: FormData = new FormData();
    formData.append("promocodeFile", fileToUpload, fileToUpload.name);
    return this.httpService.post(APIUrl.importpromocode, formData);
  }

  // consumer promotions endpoints
  postConsumerPromotions(formData) {
    const url = APIUrl.consumerPromotions;
    return this.httpService.post(url, formData);
  }

  getConsumerPromotions() {
    const url = APIUrl.consumerPromotions;
    return this.httpService.get(url);
  }

  getConsumerPromotionById(id:string) {
    const url = APIUrl.consumerPromotions;
    return this.httpService.get(`${url}/${id}`);
  }

  updateConsumerPromotions(id:string, formData) {
    const url = APIUrl.consumerPromotions;
    return this.httpService.put(`${url}/${id}`, formData);
  }
}
